import { Platform, View } from 'react-native'
import Typography from '@ui/typography'
import { statusColor } from './styles'
import { StatusProps as Props } from './types'
import cn from '@ui/utils/cn'

const borderRadius = 12

export default function Status({
  text,
  variant = 'neutral',
  size = 'default',
  colors,
  className,
  typographyProps,
}: Props) {
  const { front, back } = colors || statusColor[variant]

  return (
    <View
      style={{ borderRadius }}
      className={cn('flex h-6 justify-center self-center', className)}
    >
      <View className="absolute inset-0 bg-white" style={{ borderRadius }} />
      <View
        className="absolute inset-0"
        style={{ borderRadius, backgroundColor: back }}
      />
      <View className="px-3">
        <Typography
          variant="XSB"
          className={cn(
            'uppercase',
            Platform.select({
              default: 'tracking-[0.6]', // +5%
              web: 'tracking-[0.05em]',
            }),
            size === 'small' && 'text-[10px]'
          )}
          color={front}
          {...typographyProps}
        >
          {text}
        </Typography>
      </View>
    </View>
  )
}
